function convertSquareYardToSquareMile(num) {
  let eq =
    "Converting " +
    num +
    " square yard to square mile: \n" +
    num +
    " * 3.228305785e-7 = ";
  let rep = num * 3.228305785e-7;
  return eq + rep.toFixed(7);
}

function convertSquareYardToSquareMeter(num) {
  let eq =
    "Converting " +
    num +
    " square yard to square meter: \n" +
    num +
    " * 0.83612736 = ";
  let rep = num * 0.83612736;
  return eq + rep.toFixed(3);
}

function convertSquareYardToSquareInch(num) {
  let eq =
    "Converting " +
    num +
    " square yard to square inch: \n" +
    num +
    " * 1296 = ";
  let rep = num * 1296;
  return eq + rep.toFixed(2);
}

function convertSquareYardToSquareFoot(num) {
  let eq =
    "Converting " +
    num +
    " square yard to square foot: \n" +
    num +
    " * 9 = ";
  let rep = num * 9;
  return eq + rep.toFixed(2);
}

function convertSquareYardToHectare(num) {
  let eq =
    "Converting " +
    num +
    " square yard to hectare: \n" +
    num +
    " * 0.000083612736 = ";
  let rep = num * 0.000083612736;
  return eq + rep.toFixed(6);
}

function convertSquareYardToAcre(num) {
  let eq =
    "Converting " +
    num +
    " square yard to acre: \n" +
    num +
    " * 0.0002066115702 = ";
  let rep = num * 0.0002066115702;
  return eq + rep.toFixed(5);
}

export {
  convertSquareYardToSquareMile,
  convertSquareYardToAcre,
  convertSquareYardToHectare,
  convertSquareYardToSquareFoot,
  convertSquareYardToSquareInch,
  convertSquareYardToSquareMeter
};
